import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeEvery } from "redux-saga/effects";

import { firestore, rsf } from "../../../init/firebase";
import { AppResource } from "../../../types/resource.types";
import { getChatRoomsAction } from "../redux/actions";
import { setChatRooms, setChatRoomsLoading } from "../redux/reducer/chat.reducer";
import { IRoomHeader, IRooms } from "../type";
import { GetChatRoomsActionData } from "../type/queries.types";

function* getChatRooms(data: PayloadAction<GetChatRoomsActionData>): any {
  const getChatRoomsQuery = data.payload.getChatRoomsQuery;
  const userId = data.payload.userId;

  try {
    yield put(setChatRoomsLoading(true));
    const snapshot = yield call(rsf.firestore.getCollection, getChatRoomsQuery());
    if (!snapshot.empty) {
      const roomsHeader: IRoomHeader[] = [];
      let rooms: IRooms = {};
      // fetch client data and inject it to every room
      for (const doc of snapshot.docs) {
        const data = doc.data();
        const clientId = data.participants.filter((participantId: string) => userId !== participantId)[0];
        const clientSnapshot = yield firestore.collection(AppResource.clients).doc(clientId).get();

        // skip room if client is not found.
        if (!clientSnapshot.exists) continue;

        roomsHeader.push({ roomId: doc.id, lastMessageUpdate: data.lastMessage?.updatedAt });
        rooms = {
          ...rooms,
          [doc.id]: {
            ...data,
            id: doc.id,
            ref: doc.ref,
            client: clientSnapshot.data(),
          },
        };
      }
      yield put(setChatRooms({ roomsHeader, rooms }));
    }
  } catch (ex: any) {
    yield put(setChatRooms({ roomsHeader: [], rooms: {} }));
    console.log(ex.message);
  } finally {
    yield put(setChatRoomsLoading(false));
  }
}

export default function* watchGetChatRooms() {
  yield takeEvery(getChatRoomsAction.toString(), getChatRooms);
}
